import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { cn } from '~/shadcn/lib/utils'
import { Button } from '~/shadcn/ui/button/button'
import { ArrowBackIcon } from '~/@mid_ui/icons/ArrowBackIcon'

type Props = {
  color?: string
  className?: string
  route?: string
  onClick?: () => void
  children?: ReactNode
}

function BackButton({
  color = '#2E8FFF',
  className,
  route,
  onClick,
  children,
}: Props) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (route) {
      navigate(route)
    } else if (onClick) {
      onClick()
    } else {
      if (window.history.length > 1) {
        navigate(-1)
      } else {
        navigate('/')
      }
    }
  }

  return (
    <Button
      variant="ghost"
      onClick={handleClick}
      className={cn('h-6.5 p-0 has-[>svg]:p-0 gap-1 text-[1rem]', className)}
      style={{ color }}>
      <ArrowBackIcon
        height={24}
        width={24}
        className={cn('w-6! h-6!', className)}
      />
      {children && <span>{children}</span>}
    </Button>
  )
}

export { BackButton }
